import React from "react";
import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import axios from '../../axios/axiosconf';
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Loading from "../general/Loading";
import Swal from 'sweetalert2';

function ParametrosWhatsapp() {

    const [loggedIn, setLoggedIn] = useState(false);
    const [client, setClient] = useState([]);

    // Form States
    const [provider, setProvider] = useState('twilio');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [configData, setConfigData] = useState({});
    const [loadingSave, setLoadingSave] = useState(false);
    const [testNumber, setTestNumber] = useState('');

    let userdata = [];

    useEffect(() => {
        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const config = {
            headers: { Authorization: 'Bearer ' + userdata.access_token }
        }

        // Get Client Info
        axios.get('/get-client?uid=' + userdata.user_id, config)
            .then(response => {
                if (response.status === 200) {
                    setClient(response.data);
                    setLoggedIn(true);
                }
            })
            .catch(error => console.log(error));

        // Get Existing WhatsApp Settings
        axios.get('/whatsapp-settings', config)
            .then(res => {
                if (res.data) {
                    setProvider(res.data.provider || 'twilio');
                    setPhoneNumber(res.data.phone_number || '');
                    setConfigData(res.data.config || {});
                }
            })
            .catch(err => console.log(err));

    }, []);

    const handleConfigChange = (e) => {
        setConfigData({
            ...configData,
            [e.target.name]: e.target.value
        });
    }

    const saveSettings = (e) => {
        e.preventDefault();
        setLoadingSave(true);
        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }
        const config = { headers: { Authorization: 'Bearer ' + userdata.access_token } }

        const payload = {
            provider,
            phone_number: phoneNumber,
            config: configData,
            is_active: true
        };

        axios.post('/whatsapp-settings', payload, config)
            .then(res => {
                Swal.fire('Guardado', 'Configuración de WhatsApp actualizada.', 'success');
                setLoadingSave(false);
            })
            .catch(err => {
                Swal.fire('Error', 'No se pudo guardar la configuración.', 'error');
                setLoadingSave(false);
            });
    }

    const sendTestMessage = () => {
        if (!testNumber) return Swal.fire('Error', 'Ingrese un número para probar', 'warning');

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }
        const config = { headers: { Authorization: 'Bearer ' + userdata.access_token } }

        axios.post('/whatsapp-test', { to: testNumber, message: 'Mensaje de prueba desde SmileWEB' }, config)
            .then(res => {
                Swal.fire('Enviado', 'Mensaje de prueba enviado con éxito.', 'success');
            })
            .catch(err => {
                Swal.fire('Error', 'Fallo al enviar mensaje: ' + (err.response?.data?.error || err.message), 'error');
            });
    }

    if (loggedIn) {
        return (
            <div className="hold-transition">
                <Header client={client} />
                <Aside client={client} activelink="settings" />

                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item"><Link to="/home">Home</Link></li>
                                        <li className="breadcrumb-item"><Link to="/settings">Configuración</Link></li>
                                        <li className="breadcrumb-item"><Link to="/parametros-sistema">Parámetros del Sistema</Link></li>
                                        <li className="breadcrumb-item">WhatsApp</li>
                                    </ol>
                                </div>
                            </div>
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <h1 className="m-0">Configuración de WhatsApp</h1>
                                </div>
                            </div>
                        </div>
                    </div>

                    <section className="content">
                        <div className="container-fluid">
                            <div className="card">
                                <div className="card-header">
                                    <h3 className="card-title">Credenciales de API</h3>
                                </div>
                                <div className="card-body">
                                    <div className="form-group">
                                        <label>Proveedor</label>
                                        <select className="form-control" value={provider} onChange={(e) => setProvider(e.target.value)}>
                                            <option value="twilio">Twilio (Recomendado)</option>
                                            <option value="ultramsg">Ultramsg (QR Code / Propio Número)</option>
                                        </select>
                                    </div>

                                    <div className="form-group">
                                        <label>Número de Teléfono (Remitente)</label>
                                        <input type="text" className="form-control"
                                            value={phoneNumber} onChange={(e) => setPhoneNumber(e.target.value)}
                                            placeholder="+57300..." />
                                        <small className="text-muted">El número asociado a la cuenta de WhatsApp.</small>
                                    </div>

                                    {provider === 'twilio' && (
                                        <>
                                            <div className="alert alert-info">
                                                <strong><i className="fas fa-info-circle"></i> Configuración Twilio</strong>
                                                <p className="mb-1">Puedes usar <strong>Auth Token</strong> (más simple) o <strong>API Key</strong> (más segura para producción).</p>
                                                <small>
                                                    • <strong>Auth Token:</strong> Llena SID + Auth Token<br/>
                                                    • <strong>API Key:</strong> Llena SID + API Key (SK...) + Secret
                                                </small>
                                            </div>

                                            <div className="form-group">
                                                <label>Account SID <span className="text-danger">*</span></label>
                                                <input type="text" className="form-control" name="sid"
                                                    value={configData.sid || ''} onChange={handleConfigChange}
                                                    placeholder="AC..." />
                                                <small className="text-muted">Empieza con AC... (ejemplo: AC7fe03a558c6d44ee0a09f81172f66307)</small>
                                            </div>

                                            <div className="form-group">
                                                <label>From Number (WhatsApp) <span className="text-danger">*</span></label>
                                                <input type="text" className="form-control" name="from"
                                                    value={configData.from || ''} onChange={handleConfigChange}
                                                    placeholder="whatsapp:+16802066315" />
                                                <small className="text-muted">Formato: whatsapp:+[código país][número] (ejemplo: whatsapp:+16802066315)</small>
                                            </div>

                                            <hr />
                                            <h5>Opción 1: Auth Token (Simple)</h5>
                                            
                                            <div className="form-group">
                                                <label>Auth Token</label>
                                                <input type="password" className="form-control" name="token"
                                                    value={configData.token || ''} onChange={handleConfigChange}
                                                    placeholder="Dejar vacío si usas API Key" />
                                                <small className="text-muted">Encuéntralo en tu Twilio Console Dashboard</small>
                                            </div>

                                            <hr />
                                            <h5>Opción 2: API Key (Recomendada para Producción)</h5>
                                            
                                            <div className="form-group">
                                                <label>API Key SID</label>
                                                <input type="text" className="form-control" name="apikey"
                                                    value={configData.apikey || ''} onChange={handleConfigChange}
                                                    placeholder="SK..." />
                                                <small className="text-muted">Empieza con SK... (ejemplo: SKd789eb1aa16c31b6b48307e68f3e390f)</small>
                                            </div>

                                            <div className="form-group">
                                                <label>API Key Secret</label>
                                                <input type="password" className="form-control" name="secret"
                                                    value={configData.secret || ''} onChange={handleConfigChange}
                                                    placeholder="Secret de la API Key" />
                                                <small className="text-muted">Solo se muestra una vez al crear la API Key en Twilio</small>
                                            </div>
                                        </>
                                    )}

                                    {provider === 'ultramsg' && (
                                        <>
                                            <div className="form-group">
                                                <label>Instance ID</label>
                                                <input type="text" className="form-control" name="instance_id"
                                                    value={configData.instance_id || ''} onChange={handleConfigChange} />
                                            </div>
                                            <div className="form-group">
                                                <label>Token</label>
                                                <input type="password" className="form-control" name="token"
                                                    value={configData.token || ''} onChange={handleConfigChange} />
                                            </div>
                                        </>
                                    )}

                                    <button className="btn btn-primary" onClick={saveSettings} disabled={loadingSave}>
                                        {loadingSave ? 'Guardando...' : 'Guardar Configuración'}
                                    </button>
                                </div>
                            </div>

                            <div className="card mt-3">
                                <div className="card-header bg-success">
                                    <h3 className="card-title"><i className="fas fa-paper-plane"></i> Probar Envío de WhatsApp</h3>
                                </div>
                                <div className="card-body">
                                    <div className="alert alert-warning">
                                        <strong><i className="fas fa-exclamation-triangle"></i> Importante:</strong>
                                        <p className="mb-0">Asegúrate de haber guardado la configuración antes de probar. El número debe estar en formato internacional con código de país.</p>
                                    </div>
                                    
                                    <div className="form-group">
                                        <label>Número Destino <span className="text-danger">*</span></label>
                                        <input type="text" className="form-control"
                                            value={testNumber} onChange={(e) => setTestNumber(e.target.value)}
                                            placeholder="+573001234567" />
                                        <small className="text-muted">Formato: +[código país][número] (ejemplo: +573001234567 para Colombia)</small>
                                    </div>
                                    
                                    <button className="btn btn-success btn-lg" onClick={sendTestMessage}>
                                        <i className="fab fa-whatsapp"></i> Enviar Mensaje de Prueba
                                    </button>
                                </div>
                            </div>

                        </div>
                    </section>
                </div>
                <Footer showToast={false} delay={0} />
            </div>
        );
    }

    return <Loading />;
}

export default ParametrosWhatsapp;
